// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1XVdF","resendInfoText":"OnGoingPaymentBox_resendInfoText__12xvf"};